module.exports = __webpack_public_path__ + "fonts/CircularSpUIv3T-Bold.8d0a45c.woff2";